export const ingredients = [
  {
    id: 'to-buy',
    items: [
      {
          name: 'Asparagus',
          number: '1',
          unit: 'bunch'
      },
      {
          name: 'English peas (unshelled)',
          number: '1',
          unit: 'cup',
          numberMetric: '225',
          unitMetric: 'g'
      },
      {
          name: 'Shallots',
          number: '4'
      },
      {
          name: 'Heavy cream',
          number: '1.25',
          unit: 'cups',
          numberMetric: '296',
          unitMetric: 'g'
      },
      {
          name: 'Saffron',
          number: '2',
          unit: 'Tbsp'
      },
      {
          name: 'Lemon (zest)',
          number: '1'
      },
      {
          name: 'Parmesan (grated)',
          number: '0.5',
          unit: 'cup',
          numberMetric: '50',
          unitMetric: 'g'
      },
      {
          name: 'Parsley',
          number: '4',
          unit: 'Tbsp'
      },
      {
          name: 'Tarragon',
          number: '4',
          unit: 'Tbsp'
      },
      {
          name: 'Pasta',
          number: '4',
          unit: 'servings',
          note: 'wide, like fettuccine or tagliatelle'
      }
    ]
  },
  {
    id: 'pantry',
    name: 'Pantry',
    items: [
        { name: 'Olive oil' },
        { name: 'Salt' },
        { 
            name: 'Flakey sea salt',
            note: 'optional'
        }
    ]
  }
]